import React, { useEffect } from 'react';
import PaymentSelectionBase from '../../components/paymentSelectionBase/paymentSelectionBase';
import { SegmentProps } from '../../state-machine/actions/segment';
import { useTranslation } from 'react-i18next';

export enum PaymentSelectionErrors {
  'internetBankError' = 'internetBankError',
  'ineligibleError' = 'ineligibleError',
  'plaidError' = 'plaidError',
}

type PaymentSelectionErrorProps = SegmentProps & {
  onPlaidClick: () => void;
  onManualClick: () => void;
  errorType: PaymentSelectionErrors;
  internetBankName?: string;
  plaidRequired?: boolean;
};

type ErrorDisplayTextType = { [ErrType in PaymentSelectionErrors]: any };

const PaymentSelectionError: React.FC<PaymentSelectionErrorProps> = ({
  onPlaidClick,
  onManualClick,
  errorType,
  internetBankName,
  track,
  page,
  plaidRequired = false,
}) => {
  useEffect(() => {
    page('Payment Selection Error');
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { t } = useTranslation();
  const errorDisplayText: ErrorDisplayTextType = {
    internetBankError: {
      header: t(($) => $.error.internetBankErrorHeader),
      message: t(($) => $.error.internetBankErrorMessage, {
        internetBankName,
      }),
      primaryButtonText: t(($) => $.error.paymentSelectionErrorPrimaryButtonText),
    },
    ineligibleError: {
      header: t(($) => $.error.ineligibleErrorHeader),
      message: t(($) => $.error.ineligibleErrorMessage),
      primaryButtonText: t(($) => $.error.paymentSelectionErrorPrimaryButtonText),
    },
    plaidError: {
      header: t(($) => $.error.plaidErrorHeader),
      message: t(($) => $.error.plaidErrorMessage),
      primaryButtonText: t(($) => $.error.tryAgain),
    },
  };

  useEffect(() => {
    track('Payment selection error', { type: errorType });
  }, [errorType]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <PaymentSelectionBase
      header={errorDisplayText[errorType].header}
      subText={errorDisplayText[errorType].message}
      primaryButtonText={errorDisplayText[errorType].primaryButtonText}
      primaryButtonAction={onPlaidClick}
      secondaryButtonAction={onManualClick}
      plaidRequired={plaidRequired}
      track={track}
      error={true}
    />
  );
};

export default PaymentSelectionError;
